export function routeToLink(route) {
    const routeLinksMap = {
        'why-answers': 'why-answers',
        'results-with-answers': 'why-answers',
        'customers': 'why-answers',
        'future-of-customer-support': 'why-answers',
        'full-platform': 'platform',
        'integrations': 'platform',
        'knowledge-management': 'platform',
        'knowledge-management-use-cases': 'platform',
        'knowledge-management-features': 'platform',
        'ticketing-system': 'platform',
        'call-center-software': 'platform',
        'help-widget': 'platform',
        'live-chat-software': 'platform',
        'insights': 'platform',
        'spotter-automations': 'platform',
        'control-room': 'platform',
        'top-issues': 'platform',
        'csat': 'platform',
        'smb': 'solutions',
        'enterprise': 'solutions',
        'omnichannel-support': 'solutions',
        'self-service': 'solutions',
        'proactive-support': 'solutions',
        'customer-interactions': 'solutions',
        'pricing': 'pricing',
        'cx-library': 'explore',
        'blog': 'explore',
        'video-tutorials': 'explore',
        'developers': 'explore'
    }

    return routeLinksMap[route];
}     

export function kmRouteToLink(route) {
    const kmRouteLinkMap = {
        'knowledge-management': 'overview',
        'knowledge-management-use-cases': 'use-cases',
        'knowledge-management-features': 'features'
    }

    return kmRouteLinkMap[route];
}